import React from "react";
// style components
import { Row, Col, Modal, Form, Input, Button } from "antd";
// models
import { initialValuesReconocimientoModel, ReconocimientosModel } from "../../../models/Reconocimientos/reconocimientos.models";
//  hook
import { useReconocimientosjurados } from "../../../hooks/useReconocimientosjurados";
import DocumentInput from "../../../utils/DocumentInput";
import DocumentosService  from "../../../api/Documentos/api-documentos";

interface IProps {
  reconocimiento: ReconocimientosModel;
  setReconocimiento: any;
  reconocimientos: Array<ReconocimientosModel>;
  setReconocimientos: any;
  modal: boolean;
  setModal: any;
  guardarcambios: any;
  limpiarcampos: any;
  guardarArchivoeditar: any;
  indexReconocimiento: number;
}

export const Modaleditarconocimiento: React.FC<IProps> = (props: IProps) => {
  const { fileInputRef } = useReconocimientosjurados();
  const fields = [
    { name: "nombre_reconocimiento", value: props.reconocimiento.nombre_reconocimiento },
    { name: "institucion_otorga", value: props.reconocimiento.institucion_otorga },
    { name: "año", value: props.reconocimiento.año },
    { name: "ciudad", value: props.reconocimiento.ciudad },
    { name: "documento", value: props.reconocimiento.documento },
  ];

  const onCancel = () => {
    props.setReconocimiento(initialValuesReconocimientoModel)
    props.setModal(false)
  }

  const guardarArchivo = async (e: any) => {
    if (e.target.files.length > 0) {
      const formData = new FormData();
      formData.append("archivo", e.target.files[0]);
      const data = await DocumentosService.guardarArchivo(formData);
      return props.setReconocimiento({ ...props.reconocimiento, documento: data.data });
    }
  };


  return (
    <Modal
      title={
        <span className="font-family-Montserrat-Bold">
          Editar reconocimiento {(<div className="d-sm d-md-none"></div>)}
          <span>
            - <span className="font-color-DB2828 font-size-10px font-family-Montserrat-Regular">
              Todos los campos son obligatorios
            </span>
          </span>

        </span>
      }
      style={{ top: 60 }}
      width={1600}
      visible={props.modal}
      onCancel={onCancel}
      footer={[
        <Button key="b_cancel_modaleditCono" className="button-gray-ghost" onClick={onCancel}>
          Cancelar
        </Button>,
        <Button key="b_limpiar_modaleditCono" style={{ marginBottom: '20px' }} className="button-azul-ghost font-size-12px" onClick={() => props.limpiarcampos()}>
          Limpiar campos
        </Button>,
        <Button className="button-azul-radius" form="modaleditarreconocimiento" key="submit" htmlType="submit">
          Guardar cambios
        </Button>,
      ]}
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144 ,0.8)",
      }}
    >
      <Form
        size="large"
        name="modaleditarreconocimiento"
        fields={fields}
        onFinish={props.guardarcambios}
        onFieldsChange={(_, fields: any) => {
          let infoupdate: any = { ...props.reconocimiento };
          for (const i in fields) {
            infoupdate[fields[i].name] = fields[i].value;
          }
          return props.setReconocimiento(infoupdate);
        }}
      >
        <div className="row">
          <div className="col-12 col-md-6 col-lg-6 mt-3">
            <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom">
              Nombre del reconocimiento
            </span>
            <Form.Item
              className="no-margin"
              name="nombre_reconocimiento"
              rules={[{ required: true, message: "" }]}
            >
              <Input />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 mt-3">
            <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom">
              Institución que lo otorga
            </span>
            <Form.Item className="no-margin" name="institucion_otorga" rules={[{ required: true, message: "" }]}>
              <Input />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 mt-3">
            <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom">
              Año
            </span>
            <Form.Item className="no-margin" name="año" rules={[{ required: true, message: "" }]}>
              <Input />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-6 mt-3">
            <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom">
              Ciudad
            </span>
            <Form.Item className="no-margin" name="ciudad" rules={[{ required: true, message: "" }]}>
              <Input />
            </Form.Item>
          </div>
          {/* <div className="col-12 col-md-12 col-lg-12 mt-3">
            <span className="width-100 font-family-Montserrat-SemiBold font-size-12px no-margin">
              Breve descripción
            </span>
            <Form.Item className="no-margin" name="descripcion" rules={[{ required: true, message: "" }]}>
              <Input.TextArea maxLength={300} showCount={true} />
            </Form.Item>
          </div> */}
          <div className="col-12 col-md-6 mt-3">
            <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom">
              Anexar documento
            </span>
            <Row>
              <Col span={24}>
                <Form.Item className="no-margin" name="documento" rules={[{ required: true, message: "Documento obligatorio" }]}>
                  <DocumentInput
                    doc={props.reconocimiento.documento}
                    fileInputRef={fileInputRef}
                    ancho_btn={30}
                    on_change={(e) => {
                      guardarArchivo(e);
                      e.target.value = ""
                    }}
                    onDelete={() => {
                      props.setReconocimiento({
                        ...props.reconocimiento,
                        documento: "",
                      });
                    }}
                  />
                  {/* <Input.Group compact>
                    <Input
                      style={{ width: "70%" }}
                      disabled={true}
                      value={props.reconocimiento.documento}
                    />
                    <Button
                      style={{ width: "30%" }}
                      type="primary"
                      className="buttonblanco-radius-input"
                      onClick={() => fileInputRef.current.click()}
                    >
                      Adjuntar
                    </Button>
                    <input
                      ref={fileInputRef}
                      type="file"
                      hidden
                      onChange={(e) => {
                        guardarArchivoeditar(e, props.reconocimientos, props.indexReconocimiento)
                        e.target.value = ""
                      }}
                    />
                  </Input.Group> */}
                </Form.Item>
              </Col>
            </Row>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
